module.exports = __webpack_public_path__ + "static/knight-ac8f0081f4fc81f599d98229f14cce74.svg";